import Vue from 'vue';
import Component from 'vue-class-component';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { maxLength, required } from 'vuelidate/lib/validators';
import { Prop, Emit } from 'vue-property-decorator';
import KEYS from '@/values/keys';

@Component({
  name: 'ed-create-component-course'
})
export default class EdCreateComponentCourse extends Vue {

  @Prop() readonly params: any;

  public form: any = null;
  public saving: boolean = false;
  public isLoad = false;


  @Emit('showCustomizeEduacComponent')
  showParentForm(data) {
    return data;
  }

  get buttonsDisabled() {
    return this.saving;
  }

  init( name: string = '') {

    this.form = EdFormModel([
      EdInputModel('name', 
        name, {
        required,
        maxLength: maxLength(60)
      })
    ]);
  }

  closeModal() {
    this.showParentForm({});
  }

  save() {
    this.saving = true;
      if(this.params.edit) {
        this.update();
      } else {
        this.create();
      }
  }
 
  async update() {
    try {
      let data = this.params.data;
      data.name = this.form.name.value;
      this.$Courses.Store.updateComponent({courseId: this.params.courseId, classId: this.params.classId, data: data});
      this.refreshAndClose();
    } catch(err) {
      this.saving = false;
      this.showErrorMessage();
    }
  }

  async create() {
    try {
      this.$Courses.Store.createComponent({courseId: this.params.courseId, classId: this.params.classId, data: {name : this.form.name.value, mandatory: false, entityId: this.params.courseId, entityType: 'CONTENT'}});
      this.refreshAndClose();
    } catch(err) {
      this.saving = false;
      this.showErrorMessage();
    }
  }

  refreshAndClose() {
    const $root: any = this.$root;
    this.saving = false;
    this.closeModal();
  }

  showErrorMessage() {
    let body = this.$i18n.t('courses.eduacComponents.errorSaving');
    this.$EdModal.createMessageModal({
      body,
      title: this.$i18n.t('courses.eduacComponents.errorSavingTitle'),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

  created() {
    if(this.params.edit) {
      this.init(
        this.params.data.name
      );
    } else {
      this.init();
    }
    
    setTimeout(() => { this.isLoad = true; }, 1000);
  }

}